export const BrandMark = ({ compact = false, variant = "sidebar" }: { compact?: boolean; variant?: "sidebar" | "login" | "footer" }) => {
  if (variant === "login") {
    return (
      <div className="flex items-center" data-testid="brand-mark-login">
        <img src="/assets/logo/aczon-origin.svg" alt="ACZON Farms Ltd — Crafting with nature" className="h-[88px] w-[220px] object-contain object-left" />
      </div>
    );
  }

  if (variant === "footer") {
    return (
      <div className="flex items-center gap-2" data-testid="brand-mark-footer">
        <img src="/assets/logo/aczon-whiten.svg" alt="ACZON Farms Ltd" className="h-7 w-auto shrink-0" />
      </div>
    );
  }

  // Sidebar variant (default)
  if (compact) {
    return (
      <div className="flex items-center justify-center" data-testid="brand-mark-compact">
        <img
          src="/assets/logo/aczon-transparent.svg"
          alt="ACZON Farms Ltd"
          className="h-[62px] w-[62px] shrink-0 scale-[1.35] object-contain"
        />
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-center" data-testid="brand-mark">
      <img src="/assets/logo/aczon-transparent.svg" alt="ACZON Farms Ltd — Crafting with nature" className="h-[126px] w-[258px] scale-[1.12] object-contain" />
    </div>
  );
};
